import React from "react";
import AppRoutes from "routers/index";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>MyDyo</title>
        <meta
          name=""
          content="MyDyo"
        />
      </Helmet>

      {/* MAIN APP */}
      <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
        <AppRoutes />
      </div>
    </HelmetProvider>
  );
}

export default App;
